module.exports = __webpack_public_path__ + "img/mobile-map-background.16c11aa7.png";